export default "__VITE_ASSET__4cab3e90__"